import React, { useEffect, useState } from "react";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";

import { Col, Row } from "react-bootstrap";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import Button from "../../../components/shared/buttons/button";

import {
  useUpdateMoistureRoomDataMutation,
  useUpdateReworkLogDataMutation,
} from "./reworkApi";
import MultiSelect from "../../../components/shared/fields/Multiselect";
import { useUpdateOvenDataMutation } from "../../processing/cooking/cookingApi";
import useTranslator from "../../../hooks/useTranslator";
import { getCurrentDate } from "../../../helpers/Utils";

const EditHumidityModal = ({ show, setShow, record, mode }) => {
  const { _t } = useTranslator();  
  const currentDate = getCurrentDate("YYYY-MM-DD");
  const [date, setDate] = useState(currentDate);  
  const [multiSelectData, setMultiSelectData] = useState({});
  const [updateData] = useUpdateOvenDataMutation();
  const [updateToastedData] = useUpdateMoistureRoomDataMutation();
  const handleMultiSelectChange = (updatedSelectedOptions) => {
    setMultiSelectData(updatedSelectedOptions);

    setFormData((prev) => ({
      ...prev,
      ...updatedSelectedOptions, // Spread new selected values directly
    }));
  };

  //   const [createEmployee, { isLoading: isCreating }] =
  //     useCreatePackingEmployeeDataMutation();
  const [updateReworkData, { isLoading: isUpdating }] =
    useUpdateReworkLogDataMutation();
  const getType = (type) => {
    if (type === "seconds") return _t("seconds_kg", "Seconds KG");
    if (type === "humidity") return _t("humidity_kg", "Humidity KG");
    if (type === "green") return _t("green_kg", "Green KG");
    if (type === "bone_seed") return _t("bone_seed_kg", "Bone/Seed KG");
    if (type === "toasted") return _t("toasted", "Toasted");
    if (type === "strange_material") return _t("strange_material", "Strange Material");
    return _t("spot", "Spot");
  };


  const initialFormData = {
    created_at: "",
    entity_type: "",
    total_kg: "",
    prime: "",
    strips: "",
    seconds: "",
    humidity: "",
    green: "",
    bone_seed: "",
    toasted: "",
    strange_material: "",
    spot: "",
    trash: "",
    lot_number: "",
    cart_weight: "",
    cheeks_cart_weight: "",
    strips_cart_weight: "",
    selectedOptions: {},
    type: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  useEffect(() => {
    if ((mode === "editHumidity" || mode === "editToasted") && record) {
      setFormData((prev) => {
        const resetValues = Object.keys(initialFormData).reduce((acc, key) => {
          acc[key] =
            key === "created_at"
              ? record[key]?.split(" ")[0] || prev[key] // Keep only the date part
              : [
                "total_kg",
                "lot_number",
                "entity_type",
                "cheeks_cart_weight",
                "strips_cart_weight",
                "cart_weight",
                "type",
              ].includes(key)
                ? record[key] || prev[key] // Keep these values from record
                : 0; // Reset everything else to "0"
          if(acc[key] == 0) {
            acc[key] = "";
          }
          return acc;
        }, {});

        return { ...prev, ...resetValues, selectedOptions: {} }; // Ensure selectedOptions is cleared
      });
    }
  }, [mode, record, show]);
  const handleClose = () => {
    setShow(false);
  };

  const handleSubmit = async (e) => {
    let updatedFormData = { ...formData };

    if (mode === "editHumidity") {
      const entityType = record.type;
      const isStrips = entityType === "strips";
      const cartWeight = isStrips
        ? Number(record.strips_cart_weight)
        : Number(record.cheeks_cart_weight);

      const totalKg = Number(formData.total_kg) - cartWeight;
      updatedFormData = {
        ...formData,
        humidity: Number(formData.humidity) + totalKg,
        status: "bagged",
      };
    } else if (mode === "editToasted") {
      const cartWeight = record.cart_weight;
      const totalKg = Number(formData.total_kg) - cartWeight;
      updatedFormData = {
        ...formData,
        toasted: Number(formData.toasted) + totalKg,
        status: "completed",
      };
    }

    setFormData(updatedFormData);
    const mutation = updateReworkData;

    try {
      const payload = { id: record.id, requestBody: updatedFormData };
      await mutation(payload).unwrap();

      if (mode === "editHumidity") {
        const ovenDataPayload = {
          id: record.ovenDataId,
          requestBody: updatedFormData,
        };
        await updateData(ovenDataPayload).unwrap();
      }

      if (mode === "editToasted") {
        await updateToastedData({
          id: record.toastedId,
          requestBody: { status: "completed" },
        }).unwrap();
      }

      handleClose();
    } catch (error) {
      console.error("Error creating/updating manager:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const renderFormFields = () => (
    <>
      <Col lg={6}>
        <InputWithLabel
          label={_t("date", "Date")}
          type="text"
          name="created_at"
          value={formData.created_at}
          onChange={handleChange}
          placeholder={_t("date_placeholder", "Date...")}
          disabled={true}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("lot_number", "Lot Number")}
          type="number"
          name="lot_number"
          value={formData.lot_number}
          onChange={handleChange}
          placeholder={"0"}
          disabled={true}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("type", "Type")}
          type="text"
          name="entity_type"
          value={getType(formData.entity_type)}
          placeholder={_t("reprocessing_placeholder", "Reprocessing...")}
          onChange={handleChange}
          disabled={true}
        />
      </Col>
      {mode === "editHumidity" ? (
        <Col lg={6}>
          <InputWithLabel
            label={_t("total_kg", "Total KG")}
            type="number"
            name={
              record?.type === "cheeks"
                ? "cheeks_cart_weight"
                : "strips_cart_weight"
            }
            value={
              record?.type === "cheeks"
                ? record?.cheeks_cart_weight || ""
                : record?.strips_cart_weight || ""
            }
            onChange={handleChange}
            disabled={true}
            placeholder={"0"}
          />
        </Col>
      ) : (
        <Col lg={6}>
          <InputWithLabel
            label={_t("total_kg", "Total KG")}
            type="number"
            name="cart_weight"
            value={formData.cart_weight}
            onChange={handleChange}
            disabled={true}
            placeholder={"0"}
          />
        </Col>
      )}
      <Col lg={6}>
        {record.type === "cheeks" ? (
          <>
            <Row>
              <Col lg={6}>
                <InputWithLabel
                  label={_t("total_prime_kg", "Total in Prime KG")}
                  type="number"
                  name="prime"
                  value={formData.prime}
                  onChange={handleChange}
                  placeholder={"0"}
                />
              </Col>
              <Col lg={6}>
                <InputWithLabel
                  label={_t("total_strips_kg", "Total in Strips KG")}
                  type="number"
                  name="strips"
                  value={formData.strips}
                  onChange={handleChange}
                  placeholder={"0"}
                />
              </Col>
            </Row>
          </>
        ) : (
          <Col lg={12}>
            <InputWithLabel
              label={_t("total_prime_kg", "Total in Prime KG")}
              type="number"
              name="prime"
              value={formData.prime}
              onChange={handleChange}
              placeholder={"0"}
            />
          </Col>
        )}
      </Col>
      <Col lg={6}>
        <MultiSelect
          options={[
            { value: "seconds", label: _t("seconds", "Seconds") },
            { value: "humidity", label: _t("humidity", "Humidity") },
            { value: "green", label: _t("green_kg", "Green KG") },
            { value: "bone_seed", label: _t("bone_seed", "Bone/Seed") },
            { value: "toasted", label: _t("toasted", "Toasted") },
            { value: "strange_material", label: _t("strange_material", "Strange Material") },
            { value: "spot", label: _t("spot", "Spot") },
          ]}
          value={formData.selectedOptions || []} // Ensure it's controlled
          selectedData={multiSelectData}
          onChange={handleMultiSelectChange}
        />
      </Col>

      <Col lg={6}>
        <InputWithLabel
          label={_t("total_rejected", "Total Rejected")}
          type="number"
          name="trash"
          value={formData.trash}
          onChange={handleChange}
          placeholder={"0"}
        />
      </Col>
    </>
  );
  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={
        mode === "editHumidity"
          ? _t("adding_humidity_data", "Adding Humidity Data")
          : `${_t("add_entity_log_data", "Add")}  ${getType(formData.entity_type)} ${_t("log_data", "Log Data")}`
      }
      children={formData}
    >
      <Row>{renderFormFields()}</Row>

      <Row>
        <Col className="text-end">
          <Button
            label={_t("save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
          // isLoading={isCreating || isUpdating}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default EditHumidityModal;
